import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    noticeContainer: {
      padding: '1.4rem 1.5rem',
      maxWidth: '37.5rem',
    },
    headingContainer: {
      marginBottom: '0.3rem',
      display: 'flex',
      gap: '0.5rem',
    },
    headingIconInfo: {
      alignSelf: 'center',
      color: theme.palette.green[800],

      '@media (max-width: 538px)': {
        alignSelf: 'auto',
        marginTop: '0.25rem',
      },
    },
    default: {
      border: `2px solid ${theme.palette.light[400]}`,
      backgroundColor: theme.palette.light[100],
    },
    info: {
      border: `2px solid ${theme.palette.light[400]}`,
      backgroundColor: theme.palette.light[100],
    },
    error: {
      border: `2px solid ${theme.palette.utility.redLight}`,
      backgroundColor: theme.palette.utility.noticeError,
    },
  }),
  { index: 1 },
);
